import { useEffect, useState, type ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import AppSidebar from "@/components/AppSidebar";
import hueloLogo from "@/assets/huelo-logo.svg";

interface AppShellProps {
  children: ReactNode;
}

const AppShell = ({ children }: AppShellProps) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close mobile drawer when route/tab changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  return (
    <div className="min-h-[100dvh] bg-background">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex fixed inset-y-0 left-0 w-60 border-r border-border z-30">
        <AppSidebar />
      </aside>

      {/* Mobile top bar */}
      <header className="lg:hidden sticky top-0 z-30 flex items-center justify-between px-4 h-14 bg-background border-b border-border">
        <Link to="/dashboard" className="shrink-0" aria-label="My designs">
          <img src={hueloLogo} alt="Huelo" className="h-7" />
        </Link>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button
              className="p-2 -mr-2 text-foreground"
              aria-label="Open navigation menu"
            >
              <Menu className="w-5 h-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="p-0 w-72">
            <AppSidebar onNavigate={() => setOpen(false)} />
          </SheetContent>
        </Sheet>
      </header>

      <div className="lg:pl-60 flex flex-col min-h-[100dvh]">
        {children}
      </div>
    </div>
  );
};

export default AppShell;
